import React from "react";
import {inject, observer} from "mobx-react";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";
import getRoutes from "../getRoutes";
import {numeroLisible} from "../../../util/telephonieFormat";

const TITRES = {
    sonne: "Appel entrant",
    en_cours: "En ligne",
    repondu: "Appel terminé",
    manque: "Appel manqué",
};

const COULEURS = {sonne: "#2dce89", en_cours: "#11cdef", repondu: "#8898aa", manque: "#f5365c"};

/**
 * Bandeau affiché quand la ligne du magasin sonne : numéro, client retrouvé et accès à sa fiche.
 * Alimenté en temps réel par le canal privé « telephonie » (voir DefaultHeader).
 */
const AppelEntrant = inject("rootStore")(observer(({rootStore}) => {
    const store = rootStore.telephonieStore;
    const appel = store.appelEntrant;

    if (!appel) {
        return null;
    }

    return (
        <div role="alert" style={{
            position: "fixed", top: 70, right: 16, zIndex: 2000, width: 340, maxWidth: "calc(100vw - 32px)",
            background: "#fff", borderLeft: "6px solid " + (COULEURS[appel.statut] ?? "#8898aa"),
            borderRadius: 6, boxShadow: "0 4px 18px rgba(0,0,0,.25)", padding: "12px 14px"
        }}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <strong><i className="fa fa-phone mr-2" aria-hidden="true"/>{TITRES[appel.statut] ?? "Appel"}</strong>
                <button type="button" className="close" aria-label="Fermer" onClick={() => store.fermerBandeau()}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div style={{fontSize: "1.3em", margin: "6px 0"}}>{numeroLisible(appel.numero)}</div>
            {appel.client ? (
                <>
                    <div className="mb-2">{appel.client.nom}</div>
                    <Link to={getRoutes("Modifier Client", appel.client.id)} onClick={() => store.fermerBandeau()}>
                        <Button size="sm" color="primary">Ouvrir la fiche client</Button>
                    </Link>
                </>
            ) : (
                <>
                    <div className="mb-2 text-muted">Numéro inconnu dans le CRM</div>
                    <Link to={getRoutes("Ajout Client")} onClick={() => store.fermerBandeau()}>
                        <Button size="sm" color="secondary">Créer le client</Button>
                    </Link>
                </>
            )}
        </div>
    );
}));

export default AppelEntrant;
